import { VueModule } from '@Foundation/utilities';
import RoutineFinder from './code/Scripts/components/routine-finder';
export * from './code/Scripts/store/routinestore'
export default VueModule({
  components: {
    RoutineFinder
  }
});
